import { useGetUrl } from '@seek/ca-myprofile-utils';
import { metrics } from '@seek/metrics-js';
import { useTranslations } from '@vocab/react';
import { Button, Stack, Text, TextLink } from 'braid-design-system';
import React, { useEffect } from 'react';

import { useCreateShareableProfileUrl } from 'src/components/Profile/ProfileVisibilityV2/data';
import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import { useAppConfig } from 'src/modules/appConfig';
import { hotjarEvent } from 'src/modules/hotjar';

import translations from './.vocab';

export const ConsentAndCreate = () => {
  const { t } = useTranslations(translations);
  const { zone, language, isUnifiedSite } = useAppConfig();
  const getUrl = useGetUrl(zone, language, isUnifiedSite);

  const [createShareableProfileUrl, { loading, error }] =
    useCreateShareableProfileUrl({
      key: 'profile-visibility-v2',
    });

  const { shareableProfileShareViewed, shareableProfileShareLinkClicked } =
    useAnalytics();

  useEffect(() => {
    shareableProfileShareViewed({
      eventName: 'profile_section_displayed',
      currentPage: 'profile visibility shared profile lite consent',
      profileSharedStatus: 'not generated',
    });
    // run once during on load only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickHandler = () => {
    shareableProfileShareLinkClicked({
      eventName: 'profile_update_succeeded',
      currentPage: 'profile visibility shared profile lite consent',
      profileSharedStatus: 'on',
      actionOrigin: 'profile',
      updateType: 'add',
    });
    createShareableProfileUrl({ zone, languageCode: language });
    hotjarEvent('shareable-profile-created');
    metrics.count('shareable_profile_generated');
  };

  return (
    <>
      <Stack space="large">
        <Stack space="medium">
          <Text tone="secondary">
            {t('Once you create this link, others can view...')}
          </Text>
          <Text tone="secondary">
            {t('Switch off at any time by managing your visibility...', {
              TextLink: (children) => (
                <TextLink
                  weight="weak"
                  hitArea="large"
                  href={getUrl('shareable-profile-faq-url')}
                  target="_blank"
                >
                  {children}
                </TextLink>
              ),
            })}
          </Text>
        </Stack>
        <Button
          id="consent-and-create-btn"
          data={{ automation: 'consent-and-create-btn' }}
          tone="brandAccent"
          loading={error ? false : loading}
          onClick={onClickHandler}
        >
          {t('Consent and create')}
        </Button>
      </Stack>
    </>
  );
};
